import {analytics} from '@/app/js/analytics'
import axios from 'axios'
import loadingOverlay from '@/app/js/loading-overlay'

const REST_REVIEWS_URL = '/index.php?route=product/product/restReviews'

export function initProductReviews() {
  const productReviewsEls = document.querySelectorAll('.js-product-reviews')

  if (productReviewsEls.length < 1) {
    return
  }

  productReviewsEls.forEach(productReviewsEl => {
    const contentEl = productReviewsEl.querySelector('.js-product-reviews-content')
    const showAllEl = productReviewsEl.querySelector('.js-product-reviews-show-all')

    if (!showAllEl) {
      return
    }

    showAllEl.addEventListener('click', () => {
      fetch(REST_REVIEWS_URL + '&id=' + productReviewsEl.dataset.id)
        .then(response => {
          if (response.ok) {
            return response.json()
          }
        })
        .then(json => {
          const reviews = document.createElement('div')
          reviews.innerHTML = json.toString()

          contentEl.append(...reviews.childNodes)

          showAllEl.remove()
        })
    })
  })
}

export function initProductReviewForm() {
  const formEl = document.querySelector('.js-product-review-form')

  if (!formEl) {
    return
  }

  formEl.addEventListener('submit', e => {
    e.preventDefault()

    loadingOverlay.show()

    axios({
      url: '/index.php?route=product/product/write' + '&product_id=' + formEl.dataset.id,
      headers: {'content-type': 'application/x-www-form-urlencoded'},
      method: 'post',
      data: new FormData(formEl)
    })
      .then(response => {
        loadingOverlay.hide()

        if (response.data.success) {
          analytics.productReviewSent()
          formEl.innerHTML = response.data.success
        }
      })
  })
}

export function initProductReviewsNew()
{
  const productReviewsEl = document.querySelector('.js-product-reviews-new')

  if (!productReviewsEl) {
    return
  }

  const readMoreBtns = productReviewsEl.querySelectorAll('.js-product-reviews-new-read-more')
  const showAllBtn = productReviewsEl.querySelector('.js-product-reviews-new-show-all')

  if(showAllBtn) {
    showAllBtn.addEventListener('click', () => {
      readMoreBtns[0].click()
    })
  }
}
